import XButton from "./XButton";
import {
    modalParentClasses,
    modalSizeClasses,
} from "./modalClasses";
import { cn } from "../../utils/classNames";

const modalHeaderTitleWrapperClasses = "grow";
const modalTitleClasses = "flex-1 text-left";
const modalSubtitleClasses = "text-body mb-0 text-sm";
const modalHeaderActionClasses = "flex-1 flex justify-center";
const modalCloseWrapperClasses = "flex-1 flex justify-end";
const modalCloseIconClasses = "fa fa-times text-xl!";
const footerActionWrapperClasses = "mr-auto";

const XModal = ({
    isOpen,
    title,
    subtitle,
    onClose,
    children,
    headerAction = null,
    footerAction = null,
    onSubmit,
    size = "xlg",
    submitText = "Save",
    cancelText = "Cancel",
    isSubmitting = false,
    className = "",
}) => {
    if (!isOpen) return null;

    const sizeClass = modalSizeClasses[size];

    return (
        <div className={modalParentClasses.root} data-modal-open>
            <div className={cn(modalParentClasses.dialog, sizeClass)}>
                <div className={modalParentClasses.content}>
                    <div className={modalParentClasses.header}>
                        <div className={modalHeaderTitleWrapperClasses}>
                            <h5 className={cn(modalParentClasses.title, modalTitleClasses)}>
                                {title}
                            </h5>

                            {subtitle && (
                                <p className={modalSubtitleClasses}>
                                    {subtitle}
                                </p>
                            )}
                        </div>

                        {headerAction && (
                            <div className={modalHeaderActionClasses}>
                                {headerAction}
                            </div>
                        )}

                        {onClose && (
                            <div className={headerAction ? modalCloseWrapperClasses : undefined}>
                                <XButton
                                    variant="close"
                                    onClick={onClose}
                                    disabled={isSubmitting}
                                    aria-label="Close"
                                >
                                    <i
                                        className={modalCloseIconClasses}
                                        aria-hidden="true"
                                    />
                                </XButton>
                            </div>
                        )}
                    </div>

                    <div className={cn(modalParentClasses.body, className)}>
                        {children}
                    </div>

                    {(onSubmit || footerAction) && (
                        <div className={modalParentClasses.footer}>
                            {footerAction && (
                                <div className={footerActionWrapperClasses}>
                                    {footerAction}
                                </div>
                            )}

                            {onSubmit && onClose && (
                                <XButton
                                    variant="outlinePrimary"
                                    onClick={onClose}
                                    disabled={isSubmitting}
                                >
                                    {cancelText}
                                </XButton>
                            )}

                            {onSubmit && (
                                <XButton onClick={onSubmit} disabled={isSubmitting}>
                                    {submitText}
                                </XButton>
                            )}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default XModal;